<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @resetBtn="resetBtn"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:WarehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:SynchStatus>
        <el-select multiple v-model="filters.SynchStatus" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in synchStatusList"
            :label="item.synchStatusText"
            :value="item.synchStatusId"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:IOTypeID>
        <el-select
          multiple
          filterable
          v-model="filters.IOTypeID"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in ioTypeIDList"
            :label="item.ioTypeIdText"
            :value="item.ioTypeId"
            :key="item.ioTypeId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:IOStatus>
        <el-select
          multiple
          filterable
          v-model="filters.IOStatus"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in ioStatusList"
            :label="item.ioStatusText"
            :value="item.ioStatusId"
            :key="item.ioStatusId"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="file">
        <div>
          <span v-if="scope.row.isFile==true">
            <el-link
              :underline="false"
              type="primary"
              @click.native="getReadyImages(scope.row.stockIODataID)"
            >
              预览
            </el-link>
            <el-link
              style="margin-left: 10px"
              :underline="false"
              type="primary"
              @click.native="handleImages(scope.row.stockIODataID)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>
      <template slot-scope="scope" slot="customName">
        <el-link
          :underline="false"
          type="primary"
          @click.native="stockIOdetails(scope.row.stockIODataID)"
          >查看
        </el-link>
      </template>

       <template slot-scope="scope" slot="resynchronize">
        <div>
          <span v-if="scope.row.ioStatus === 40&&(scope.row.synchStatus===99||scope.row.synchStatus===20)">
           
            <el-button
              :underline="false"
              type="text"
              size="small"
              @click.native="resynchronize(scope.row.stockIODataID)"
            >
              重新同步
            </el-button>
          </span>
              <el-button
               style="margin-left: 10px"
              :underline="false"
              type="text"
              size="small"
              @click.native="getbusinessLoglist(scope.row)"
            >
              日志
            </el-button>
          <br />
        </div>
      </template>
    </TwTable>
     
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 32, businessCode: currentRow.ioDataNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
   
    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
    <el-dialog
      :visible.sync="proListVisible"
      v-model="proListVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="商品信息"
      width="60%"
      style="text-align: center; color: black"
    >
      <div style="height: 100%">
        <el-table
          :data="stockIODataList"
          highlight-current-row
          border
          style="width: 100%;heiht"
        >
          <el-table-column
            prop="sku"
            label="SKU"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="productNameCN"
            label="SKU名称"
            min-width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="数量"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ioItemStatusText"
            label="状态"
            min-width="120"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<style>
 
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>
<script>
import {
  getStockIODataBasis,
  getStockIODataListAsync,
  exportStockIODataAsyncOut,
  getStockIODataItemByStockIODataID,
  getStockIODataReviewImages,
  getStockIODataReviewImagesFileOut,
  resynchronizeStockIOData
} from "@/api/receive/miscellaneousManage.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
export default {
  components: {LogDialog ,TwTable},
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
           width: "120",
          options: [
            {
              prop: "resynchronize",
              name: "重新同步",
              size: "small",
              type: "text",
             slot: true,
            },
            // {
            //   name: "日志",
            //   size: "small",
            //   type: "text",
            //   event: "getbusinessLoglist", // 操作的事件名
            // },
             
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "ioDataNo",
            label: "单据编号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "ioTypeIDText",
            label: "出入库类型",
            align: "center",
            sortable: true,
            minWidth: "130",
          },
          {
            prop: "externalNo",
            label: "参考编号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "ioStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
           {
            prop: "updateUser",
            label: "操作人",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "updateTimeText",
            label: "操作时间",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "customName",
            label: "产品信息",
            align: "center",
            sortable: true,
            minWidth: "110",
            slot: true,
          },
          {
            prop: "file",
            label: "附件",
            slot: true,
            minWidth: "140",
            align: "center",
          },

          {
            prop: "applicationReason",
            label: "申请原因",
            align: "center",
            sortable: true,
            minWidth: "200",
          },
          {
            prop: "synchStatusText",
            label: "同步状态",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "IODataNo",
            label: "单据编号",
            placeholder: "多个单据编号用逗号分开查询",
            clearable: true,
          },
          {
            type: "select",
            key: "IOTypeID",
            prop: "IOTypeID",
            label: "出入库类型",
            multiple: true,
            slot: true,
            placeholder: "请选择出入库类型",
            option: this.ioTypeIDList,
          },
          {
            type: "input",
            key: "ExternalNo",
            label: "参考编号",
            placeholder: "多个参考编号用逗号分开查询",
            clearable: true,
          },
          
          {
            type: "select",
            key: "IOStatus",
            prop: "IOStatus",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.ioStatusList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "WarehouseId",
            prop: "WarehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            type: "select",
            key: "SynchStatus",
            prop: "SynchStatus",
            label: "同步状态",
            multiple: true,
            slot: true,
            placeholder: "请选择同步状态",
            option: this.synchStatusList,
          },
        ],
      },
      buttonList: [],

      //-------------
      ioTypeIDList: [], //出入库类型
      warehouses: [],
      ioStatusList: [], //状态
      synchStatusList: [], //同步状态
      srcList: [], //图片路径
      proListVisible: false,
      stockIODataList:[],
    };
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询列表
    initTable() {
      const {
        IODataNo,
        IOTypeID,
        ExternalNo,
        WarehouseId,
        IOStatus,
        SynchStatus,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        IODataNo,
        IOTypeID: thereAre(IOTypeID),
        ExternalNo,
        WarehouseId: thereAre(WarehouseId),
        IOStatus: thereAre(IOStatus),
        SynchStatus: thereAre(SynchStatus),
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getStockIODataListAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let stockIODataID = row.map((item) => item.stockIODataID).join(",");
      const {
        IODataNo,
        IOTypeID,
        ExternalNo,
        WarehouseId,
        IOStatus,
        SynchStatus,
      } = this.newfilters;
      let para = {
        page: 1,
        pageSize: 60001,
        IODataNo,
        IOTypeID: thereAre(IOTypeID),
        ExternalNo,
        WarehouseId: thereAre(WarehouseId),
        IOStatus: thereAre(IOStatus),
        SynchStatus: thereAre(SynchStatus),
        stockIODataID,
      };
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportStockIODataAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //查询日志
    getbusinessLoglist(row) {
      console.log(1)
      this.currentRow = row;
      this.showLog = true;
    },
   
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
    //查询单据明细
    stockIOdetails(stockIODataID){
        getStockIODataItemByStockIODataID({ stockIODataID: stockIODataID}).then(
        (res) => {
          this.proListVisible=true;
          if (res.data.success) {
            this.stockIODataList = res.data.response;
          }
          else{
             this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
      //预览图片
    getReadyImages(id) {
      const data = {
        stockIODataID: id,
      };
     
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getStockIODataReviewImages(data).then((res) => {
        console.log(res);
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0)
          this.$viewer.show();
        
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id) {
      const data = {
        stockIODataID: id,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getStockIODataReviewImagesFileOut, {
          params: data,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //重新同步
    resynchronize(id){
       const loading = this.$loading({
        lock: true,
        text: "同步中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      resynchronizeStockIOData({ stockIODataID: id}).then(
        (res) => {
          loading.close();
          if (res.data.success) {
             this.$message({
              message: res.data.msg,
              type: "success",
             });
             this.initTable();
          }
          else{
             this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );

         
    }
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;

    getStockIODataBasis("").then((res) => {
      this.ioTypeIDList = res.data.response.ioTypeList;
      this.ioStatusList = res.data.response.ioStatusList;
      this.synchStatusList = res.data.response.synchStatusList;
    });
  },
};
</script>